import { DeleteOutlined, EditOutlined, PlusOutlined, SaveOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Row, Space, Table, Tabs, Upload, UploadFile, UploadProps } from 'antd';
import Column from 'antd/es/table/Column';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { dateCommon, validateMessages } from '../../helpers/common';
import { QuaTrinhCongTac } from '../../models/nhanvien/QuaTrinhCongTac';
import { QuaTrinhLamViecReponse } from '../../models/nhanvien/QuaTrinhLamViec';
import { luuQuaTrinhCongTac, luuQuaTrinhLamViec, xoaQuaTrinhCongTac, xoaQuaTrinhLamViec } from '../../services/nhanvien';
import ChucDanhChuyenMonSelectBox from '../utils/ChucDanhChuyenMon';
import ChucVuSelectBox from '../utils/ChucVuSelectBox';
import DonViSelectTree from '../utils/DonViSelectTree';
import DanhMucLoaiQuyetDinhSelectBox from '../utils/DanhMucLoaiQuyetDinhSelectBox';
import { TaiLieu } from '../../models/nhanvien/TaiLieu';
import { urlAdmin } from '../../constants';
import NhomNhanSuSelectBox from '../utils/NhomNhanSuSelectBox';

const { TextArea } = Input;

const QuaTrinhLamViecVaCongTacBox = ({ listCongTac, listLamViec, idNhanVien, isThemMoiLamViec, isThemMoiCongTac, onSubmit }: { listCongTac?: Array<QuaTrinhCongTac>, listLamViec?: Array<QuaTrinhLamViecReponse>, idNhanVien?: number, isThemMoiLamViec?: boolean, isThemMoiCongTac?: boolean, onSubmit: () => void }) => {
    var dataLamViec = (listLamViec || []).map((item: any, index) => { item.key = index; return item; });
    var dataCongTac = (listCongTac || []).map((item: any, index) => { item.key = index; return item; });

    const [lamViec, setLamViec] = useState<QuaTrinhLamViecReponse | null>(null);
    const [congViec, setCongViec] = useState<QuaTrinhCongTac | null>(null);
    const [idsTaiLieuXoa, setIdsTaiLieuXoa] = useState<Array<number>>([]);
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [selectedQTLV, setSelectedQTLV] = useState<QuaTrinhLamViecReponse>(new QuaTrinhLamViecReponse);
    const [loading, setLoading] = useState(false);
    const [showModalChiTiet, setShowModalChiTiet] = useState<boolean>(false);
    const [idXoa, setIdXoa] = useState<number>(0);
    const [currentTab, setCurrentTab] = useState<number>(1);
    const [form] = Form.useForm();

    const [fileListCongTac, setFileListCongTac] = useState<UploadFile[]>([]);
    const [idsTaiLieuXoaCongTac, setIdsTaiLieuXoaCongTac] = useState<Array<number>>([]);
    const [selectedQTCT, setSelectedQTCT] = useState<QuaTrinhCongTac>(new QuaTrinhCongTac());

    const setFormDetailModalLamViec = (value: QuaTrinhLamViecReponse | null) => {
        form.setFieldsValue({
            "id": value?.id,
            "idNhanVien": idNhanVien,
            "ngayBatDau": value?.ngayBatDau ? dayjs(dateCommon.formatDate(value?.ngayBatDau), "DD/MM/YYYY") : null,
            "ngayKetThuc": value?.ngayKetThuc ? dayjs(dateCommon.formatDate(value?.ngayKetThuc), "DD/MM/YYYY") : null,
            "ngayKyQD": value?.ngayKyQD ? dayjs(dateCommon.formatDate(value?.ngayKyQD), "DD/MM/YYYY") : null,
            "soQD": value?.soQD || "",
            "moTa": value?.moTa || "",
            "idDonVi": value?.idDonVi,
            "idChucVu": value?.idChucVu,
            "idChucDanhChuyenMon": value?.idChucDanhChuyenMon,
            "idNhomNhanSu": value?.idNhomNhanSu,
            "idLoaiQuyetDinh": value?.idLoaiQuyetDinh,
        });
        setLamViec(value);
        setShowModalChiTiet(true);
    }

    const setFormDetailModalCongTac = (value: QuaTrinhCongTac | null) => {
        form.setFieldsValue({
            "id": value?.id,
            "idNhanVien": idNhanVien,
            "ngayBatDau": value?.ngayBatDau ? dayjs(dateCommon.formatDate(value?.ngayBatDau), "DD/MM/YYYY") : null,
            "ngayKetThuc": value?.ngayKetThuc ? dayjs(dateCommon.formatDate(value?.ngayKetThuc), "DD/MM/YYYY") : null,
            "tenDonVi": value?.tenDonVi || "",
            "phongBan": value?.phongBan || "",
            "chucVu": value?.chucVu || "",
        });
        setCongViec(value);
        setSelectedQTCT(value ?? new QuaTrinhCongTac());
        setShowModalChiTiet(true);
    }

    const onFinish = async (values: any) => {
        try {
            setLoading(true);
            if (currentTab == 1) {
                await luuQuaTrinhLamViec(values, fileList, idsTaiLieuXoa);
                setSelectedQTLV(new QuaTrinhLamViecReponse);
                toast.success('Lưu quá trình làm việc thành công!')
            }
            else {
                await luuQuaTrinhCongTac(values, fileListCongTac, idsTaiLieuXoaCongTac);
                setSelectedQTCT(new QuaTrinhCongTac());
                toast.success('Lưu thông tin quá trình công tác thành công!')
            }
            setShowModalChiTiet(false);
        }
        catch (err: any) {
            setShowModalChiTiet(false);
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }

        setLoading(false);
        onSubmit();
    };

    const onDelete = async () => {
        try {
            setLoading(true);
            if (currentTab == 1) {
                await xoaQuaTrinhLamViec(idXoa);
                toast.success('Xoá quá trình làm việc thành công!');
            }
            else {
                await xoaQuaTrinhCongTac(idXoa);
                toast.success('Xoá thông tin quá trình công tác thành công!');
            }
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setIdXoa(0);
        setLoading(false);
        onSubmit();
    }

    useEffect(() => {
        var fileHienTai: any = (selectedQTLV?.dsTaiLieu || []).map((item: TaiLieu) => {
            return {
                uid: item.idTaiLieu + "tailieu",
                name: item.tenTep,
                status: 'done',
                url: urlAdmin + item.duongDan.replace(/\\/g, "/"),
            };
        });
        setFileList(fileHienTai)
    }, [selectedQTLV]);

    useEffect(() => {
        var fileHienTai: any = (selectedQTCT?.dsTaiLieu || []).map((item: TaiLieu) => {
            return {
                uid: item.idTaiLieu + "tailieu",
                name: item.tenTep,
                status: 'done',
                url: urlAdmin + item.duongDan.replace(/\\/g, "/"),
            };
        });
        setFileListCongTac(fileHienTai);
        setIdsTaiLieuXoaCongTac([]);
    }, [selectedQTCT]);

    const props: UploadProps = {
        onRemove: (file) => {
            if (file.uid.includes("tailieu")) {
                var id = parseInt(file.uid.split("tailieu")[0]);
                setIdsTaiLieuXoa([...idsTaiLieuXoa, id]);
            }
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            const maxSize = 20000000; // 20 MB
            if (file.size > maxSize) {
                alert('Tệp tin đính kèm không được vượt quá 20MB');
            } else {
                setFileList([...fileList, file]);
            }
            return false;
        },
        fileList,
    };

    const propsCongTac: UploadProps = {
        onRemove: (file) => {
            if (file.uid.includes("tailieu")) {
                var id = parseInt(file.uid.split("tailieu")[0]);
                setIdsTaiLieuXoaCongTac([...idsTaiLieuXoaCongTac, id]);
            }
            const index = fileListCongTac.indexOf(file);
            const newFileList = fileListCongTac.slice();
            newFileList.splice(index, 1);
            setFileListCongTac(newFileList);
        },
        beforeUpload: (file) => {
            const maxSize = 20000000; // 20 MB
            if (file.size > maxSize) {
                alert('Tệp tin đính kèm không được vượt quá 20MB');
            } else {
                setFileListCongTac([...fileListCongTac, file]);
            }
            return false;
        },
        fileList: fileListCongTac,
    };

    return (
        <div className="card-outline">
            {idXoa > 0 && currentTab == 1 ?
                <ModalTextForm show={idXoa > 0}
                    title="Xoá quá trình làm việc"
                    handleClose={() => setIdXoa(0)}
                    handleSave={onDelete}>
                    Xác nhận xóa quá trình làm việc đang chọn
                </ModalTextForm> :
                <ModalTextForm show={idXoa > 0}
                    title="Xoá thông tin quá trình công tác"
                    handleClose={() => setIdXoa(0)}
                    handleSave={onDelete}>
                    Xác nhận xóa thông tin quá trình công tác đang chọn
                </ModalTextForm>
            }
            {showModalChiTiet && currentTab == 1 ? <ModalTextForm title="Quản lý quá trình làm việc"
                hideFooter
                show={showModalChiTiet}
                handleClose={() => {
                    setShowModalChiTiet(false);
                    setSelectedQTLV(new QuaTrinhLamViecReponse);
                }}
            >
                {isThemMoiLamViec ? < Form
                    layout="vertical"
                    validateMessages={validateMessages}
                    onFinish={onFinish}
                    form={form}
                    disabled={!isThemMoiLamViec}
                >
                    <Form.Item hidden name="id"><Input /></Form.Item>
                    <Form.Item hidden name="idNhanVien"><Input /></Form.Item>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Số quyết định"
                                name="soQD"
                            >
                                <Input
                                    placeholder="Số quyết định"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Ngày quyết định"
                                name="ngayKyQD">
                                <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Đến ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Từ ngày"
                                name="ngayBatDau"
                                rules={[{ required: true }]}
                            >
                                <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Từ ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Đến ngày"
                                name="ngayKetThuc">
                                <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Đến ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item name="idDonVi" label="Phòng ban" rules={[{ required: true }]}>
                        <DonViSelectTree onChange={() => { }} />
                    </Form.Item>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="idChucVu" label="Chức vụ" rules={[{ required: true }]}>
                                <ChucVuSelectBox onChange={() => { }} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="idNhomNhanSu" label="Nhóm nhân sự" rules={[{ required: true }]}>
                                <NhomNhanSuSelectBox onChange={(e: any) => { form.setFieldValue('idNhomNhanSu', e.target.value); }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="idLoaiQuyetDinh" label="Loại quyết định">
                                <DanhMucLoaiQuyetDinhSelectBox allowClear={true} onChange={(e: any) => { form.setFieldValue('idLoaiQuyetDinh', e.target.value); }} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="idChucDanhChuyenMon" label="Chức danh chuyên môn">
                                <ChucDanhChuyenMonSelectBox allowClear={true} onChange={(e: any) => { form.setFieldValue('idChucDanhChuyenMon', e.target.value); }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item name="moTa" label="Mô tả">
                        <TextArea rows={4} placeholder="Nội dung" />
                    </Form.Item>
                    <Row>
                        <Col span="24">
                            <Upload {...props}>
                                <Button icon={<UploadOutlined rev="" />}>Thêm file</Button>
                            </Upload>
                        </Col>
                    </Row>
                    <Form.Item>
                        <Button type="primary" className="float-right" htmlType="submit" loading={loading} icon={<SaveOutlined rev="" />}>
                            Lưu
                        </Button>
                    </Form.Item>
                </Form> :
                    <>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Số quyết định</div>
                                    <label>{lamViec?.soQD}</label>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Ngày ký quyết định</div>
                                    <label>{lamViec?.ngayKyQD != null ? dateCommon.formatDate(lamViec?.ngayKyQD) : ""}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Từ ngày</div>
                                    <label>{lamViec?.ngayBatDau != null ? dateCommon.formatDate(lamViec?.ngayBatDau) : null}</label>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Đến ngày</div>
                                    <label>{lamViec?.ngayKetThuc != null ? dateCommon.formatDate(lamViec?.ngayKetThuc) : ""}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Phòng ban</div>
                                    <label>{lamViec?.tenDonVi}</label>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Chức vụ</div>
                                    <label>{lamViec?.tenChucVu}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Chức danh chuyên môn</div>
                                    <label>{lamViec?.tenChucDanhChuyenMon}</label>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Loại quyết định</div>
                                    <label>{lamViec?.tenLoaiQuyetDinh}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <div className="mb-1">
                                    <div>Mô tả</div>
                                    <label>{lamViec?.moTa}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <div className="mb-1">
                                    <div>File đính kèm</div>
                                    <Upload disabled={true} {...props}>
                                    </Upload>
                                </div>
                            </Col>
                        </Row>
                    </>}
            </ModalTextForm> : showModalChiTiet && currentTab == 2 &&
            <ModalTextForm title="Quản lý thông tin quá trình công tác"
                hideFooter
                show={showModalChiTiet}
                handleClose={() => {
                    setShowModalChiTiet(false);
                    setSelectedQTCT(new QuaTrinhCongTac());
                }}
            >{
                    isThemMoiCongTac ?
                        <Form
                            layout="vertical"
                            validateMessages={validateMessages}
                            onFinish={onFinish}
                            form={form}
                        >
                            <Form.Item hidden name="id"><Input /></Form.Item>
                            <Form.Item hidden name="idNhanVien"><Input /></Form.Item>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        label="Từ ngày"
                                        name="ngayBatDau"
                                        rules={[{ required: true }]}
                                    >
                                        <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Chọn ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label="Đến ngày"
                                        name="ngayKetThuc"
                                        rules={[{ required: true }]} >
                                        <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Chọn ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item
                                label="Đơn vị"
                                rules={[{ required: true }]}
                                name="tenDonVi" >
                                <Input />
                            </Form.Item>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        label="Phòng ban"
                                        name="phongBan"
                                        rules={[{ required: true }]} >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label="Chức vụ"
                                        rules={[{ required: true }]}
                                        name="chucVu">
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span="24">
                                    <Upload {...propsCongTac}>
                                        <Button icon={<UploadOutlined rev="" />}>Thêm file</Button>
                                    </Upload>
                                </Col>
                            </Row>
                            <Form.Item>
                                <Button type="primary" className="float-right" htmlType="submit" loading={loading} icon=<SaveOutlined rev="" />>
                                    Lưu
                                </Button>
                            </Form.Item>
                        </Form>
                        :
                        <>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <div className="mb-1">
                                        <div>Từ ngày</div>
                                        <label>{congViec?.ngayBatDau != null ? dateCommon.formatDate(congViec?.ngayBatDau) : ""}</label>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div className="mb-1">
                                        <div>Đến ngày</div>
                                        <label>{congViec?.ngayKetThuc != null ? dateCommon.formatDate(congViec?.ngayKetThuc) : ""}</label>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <div className="mb-1">
                                        <div>Đơn vị trước đây</div>
                                        <label>{congViec?.tenDonVi}</label>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div className="mb-1">
                                        <div>Phòng ban</div>
                                        <label>{congViec?.phongBan}</label>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <div className="mb-1">
                                        <div>Chức vụ</div>
                                        <label>{congViec?.chucVu}</label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col span="24">
                                    <div className="mb-1">
                                        <div>File đính kèm</div>
                                        <Upload disabled={true} {...propsCongTac}>
                                        </Upload>
                                    </div>
                                </Col>
                            </Row>
                        </>
                }
            </ModalTextForm>
            }
            <Tabs tabBarExtraContent={isThemMoiLamViec && currentTab == 1 || isThemMoiCongTac && currentTab == 2 ?
                <Button
                    className="hrm-btn hrm-btn-warning"
                    onClick={() => {
                        currentTab == 1 ? setFormDetailModalLamViec(null)
                            : setFormDetailModalCongTac(null)
                    }}
                    icon={<PlusOutlined rev="" />}
                >
                    Thêm mới
                </Button>
                : null
            } defaultActiveKey="1" onChange={(e: any) => setCurrentTab(e)} items={[
                {
                    key: '1',
                    label: 'Quá trình làm việc tại Quỹ',
                    children:
                        <div className="card">
                            <Table
                                locale={{ emptyText: "Không có dữ liệu" }}
                                dataSource={dataLamViec}
                                pagination={false}
                                rowClassName={(record, index) => {
                                    return (record?.id === idXoa) ? "selected-row row-key-" : "";
                                }}
                            >
                                <Column
                                    title="STT"
                                    key="STT"
                                    render={(value, record, index) =>
                                    (
                                        <>
                                            {index + 1}
                                        </>
                                    )
                                    }
                                />
                                <Column
                                    title="Từ ngày"
                                    key="tungay"
                                    render={(value: QuaTrinhLamViecReponse, record, index) =>
                                    (
                                        <>
                                            {dateCommon.formatDate(value?.ngayBatDau)}
                                        </>
                                    )
                                    }
                                />
                                <Column
                                    title="Đến ngày"
                                    key="denngay"
                                    render={(value: QuaTrinhLamViecReponse, record, index) =>
                                    (
                                        <>
                                            {dateCommon.formatDate(value?.ngayKetThuc)}
                                        </>
                                    )
                                    }
                                />
                                <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                                <Column title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" />
                                {/*<Column title="Chức danh " dataIndex="tenChucDanhChuyenMon" key="tenChucDanhChuyenMon" />*/}
                                <Column title="Loại quyết định" dataIndex="tenLoaiQuyetDinh" key="tenLoaiQuyetDinh" />
                                {isThemMoiLamViec ?
                                    <Column width="10%" title="" key="action"
                                        render={(value: QuaTrinhLamViecReponse, record, index) =>
                                        (
                                            <Space>
                                                <Button type="primary" size={"small"} loading={loading} title="Sửa"
                                                    icon=<EditOutlined rev="" />
                                                    onClick={() => { setFormDetailModalLamViec(value); setSelectedQTLV(value); }}
                                                >
                                                    Sửa
                                                </Button>
                                                <Button type="primary" danger size={"small"} loading={loading} title="Xóa"
                                                    onClick={() => { setIdXoa(value.id) }}
                                                    icon=<DeleteOutlined rev="" />
                                                >
                                                    Xóa
                                                </Button>
                                            </Space>
                                        )
                                        }
                                    /> :
                                    <Column width="10%" title="" key="action"
                                        render={(value: QuaTrinhLamViecReponse, record, index) =>
                                        (
                                            <Space>
                                                <Button type="primary" size={"small"} loading={loading} title="Xem"
                                                    icon=<EyeOutlined rev="" />
                                                    onClick={() => { setFormDetailModalLamViec(value); setSelectedQTLV(value); }}
                                                >
                                                    Xem
                                                </Button>
                                            </Space>
                                        )
                                        }
                                    />
                                }
                            </Table>
                        </div>
                },
                {
                    key: '2',
                    label: 'Quá trình công tác',
                    children:
                        <div className="card">
                            <Table
                                locale={{ emptyText: "Không có dữ liệu" }}
                                dataSource={dataCongTac}
                                pagination={false}
                                rowClassName={(record, index) => {
                                    return (record?.id === idXoa) ? "selected-row row-key-" : "";
                                }}
                            >
                                <Column
                                    title="STT"
                                    key="STT"
                                    render={(value, record, index) =>
                                    (
                                        <>
                                            {index + 1}
                                        </>
                                    )
                                    }
                                />
                                <Column
                                    title="Từ ngày"
                                    key="tungay"
                                    render={(value: QuaTrinhCongTac, record, index) =>
                                    (
                                        <>
                                            {dateCommon.formatDate(value?.ngayBatDau)}
                                        </>
                                    )
                                    }
                                />
                                <Column
                                    title="Đến ngày"
                                    key="denngay"
                                    render={(value: QuaTrinhCongTac, record, index) =>
                                    (
                                        <>
                                            {dateCommon.formatDate(value?.ngayKetThuc)}
                                        </>
                                    )
                                    }
                                />
                                <Column title="Đơn vị" dataIndex="tenDonVi" key="tenDonVi" />
                                <Column title="Phòng ban" dataIndex="phongBan" key="phongBan" />
                                <Column title="Chức vụ" dataIndex="chucVu" key="chucVu" />
                                {isThemMoiCongTac ?
                                    <Column width="10%" title="" key="action"
                                        render={(value: QuaTrinhCongTac, record, index) =>
                                        (
                                            <Space>
                                                <Button type="primary" size={"small"} loading={loading} title="Sửa"
                                                    icon={<EditOutlined rev="" />}
                                                    onClick={() => { setFormDetailModalCongTac(value); }}
                                                >
                                                    Sửa
                                                </Button>
                                                <Button type="primary" danger size={"small"} loading={loading} title="Xóa"
                                                    onClick={() => { setIdXoa(value.id) }}
                                                    icon={<DeleteOutlined rev="" />}
                                                >
                                                    Xóa
                                                </Button>
                                            </Space>
                                        )
                                        }
                                    /> :
                                    <Column width="10%" title="" key="action"
                                        render={(value: QuaTrinhCongTac, record, index) =>
                                        (
                                            <Space>
                                                <Button type="primary" size={"small"} loading={loading} title="Sửa"
                                                    icon={<EyeOutlined rev="" />}
                                                    onClick={() => { setFormDetailModalCongTac(value); }}
                                                >
                                                    Xem
                                                </Button>
                                            </Space>
                                        )
                                        }
                                    />
                                }
                            </Table>
                        </div>
                },
            ]}>
            </Tabs>
        </div>
    );
};

export default QuaTrinhLamViecVaCongTacBox;